import type { FocusEvent, ReactNode } from 'react';

import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';
import { cardMask } from '../../../../../../_metronic/_helpers/MasksHelper';
import useCreditCardFlagSVG from 'app/hooks/useCreditCardFlagSVG';

import InputText from '../InputText';
import * as S from './InputCardNumber.styles';

const DEFAULT_INPUT_HEIGHT = '40px';
const MASKED_MAX_LENGTH = 19;

type InputCardNumberProps = {
  id?: string;
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  borderColor?: string;
  inputHeight?: string;
  width?: string;
  mutedWhenInactive?: boolean;
  'data-testid'?: string;
};

const InputCardNumber = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  name,
  placeholder = '0000 0000 0000 0000',
  disabled = false,
  required = false,
  borderColor,
  inputHeight = DEFAULT_INPUT_HEIGHT,
  width,
  mutedWhenInactive = false,
  'data-testid': testId,
}: InputCardNumberProps) => {
  const { svg } = useCreditCardFlagSVG({ cardNumber: value });

  return (
    <S.Wrapper width={width}>
      <InputText
        id={id}
        label={label}
        name={name}
        required={required}
        placeholder={placeholder}
        value={cardMask(value)}
        onChange={(event) => {
          onChange(event.target.value.replace(/\D/g, ''));
        }}
        onBlur={onBlur}
        maxLength={MASKED_MAX_LENGTH}
        disabled={disabled}
        borderColor={borderColor}
        inputHeight={inputHeight}
        mutedWhenInactive={mutedWhenInactive}
        inputMode="numeric"
        autoComplete="cc-number"
        data-testid={testId}
        endAdornment={
          <S.BrandIcon
            src={toAbsoluteUrl(svg)}
            alt=""
            aria-hidden="true"
            data-testid="card-brand-icon"
          />
        }
      />
    </S.Wrapper>
  );
};

export default InputCardNumber;
